import { lazy } from "react";

import { isBrowser, isTablet } from "utils/deviceDetect";

// 端末ごとに画面を切り替え、使わない端末の画面は読み込まない
export const OrderEdit = lazy(() =>
  isBrowser
    ? import("pages/OrderDetail/pc/OrderEdit")
    : isTablet
      ? import("pages/OrderDetail/tb/OrderEdit")
      : import("pages/OrderDetail/sp/OrderEdit")
);

export const Estimates = lazy(() =>
  isBrowser
    ? import("pages/OrderDetail/pc/Estimates")
    : isTablet
      ? import("pages/OrderDetail/tb/Estimates")
      : import("pages/OrderDetail/sp/Estimates")
);

export const AcceptForm = lazy(() =>
  isBrowser
    ? import("pages/OrderDetail/pc/AcceptFrom")
    : isTablet
      ? import("pages/OrderDetail/tb/AcceptFrom")
      : import("pages/OrderDetail/sp/AcceptForm")
);

export const RejectForm = lazy(() =>
  isBrowser
    ? import("pages/OrderDetail/pc/RejectForm")
    : isTablet
      ? import("pages/OrderDetail/tb/RejectForm")
      : import("pages/OrderDetail/sp/RejectForm")
);
